import styled from '@emotion/styled';
import { AnimationSpec } from 'chart.js';
import DashboardWidget, { WidgetData } from '../../DashboardWidget';
import { ColorMap } from '../../Reusable/chartConfig';
import DailyReportsWidget from './DailyReportsWidget';

const DailyReports = ({ title, caption }: WidgetData) => {
  return (
    <DashboardWidget {...{ title }} {...{ caption }}>
      {(colorMap: ColorMap, loading: boolean, animation: AnimationSpec<any>) => <DailyReportsWidget />}
    </DashboardWidget>
  );
};

export default DailyReports;
